<template>
    <el-dialog
        class="rectification-dialog-container"
        :visible.sync="dialogShow"
        width="460px"
        :close-on-click-modal="false"
        :show-close="false"
        height="600px">
        <div class="rectification-dialog-content">
            <el-form
                ref="rectificationForm"
                :label-position="'top'"
                :rules="rules"
                :model="rectificationForm"
                label-width="80px">
                <el-form-item v-if="dialogType === 'noNeedEdit'" label="无需整改原因" prop="reason">
                    <el-input
                        type="textarea"
                        :rows="5"
                        placeholder="请输入内容"
                        :show-word-limit="true"
                        maxlength="250"
                        v-model="rectificationForm.reason"></el-input>
                </el-form-item>
                <el-form-item v-if="dialogType === 'followUpPerson'" label="选择整改跟进人" prop="mipName">
                    <el-input placeholder="选择整改跟进人" v-model="rectificationForm.mipName" readonly>
                        <el-button slot="append" icon="el-icon-search" @click="handleOpenGroup"></el-button>
                    </el-input>
                </el-form-item>
            </el-form>
            <GroupDialog :checkPerStatus="openPerDialog" @perDialog="overPerDialog" @closePerDialog="closePerDialog" v-if="openPerDialog.showDialog"></GroupDialog>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button v-if="dialogType === 'noNeedEdit'" :loading="submitLoading" type="primary" @click="onConfirm">
                确定
            </el-button>
            <el-button
                v-if="dialogType === 'followUpPerson'"
                :loading="submitLoading"
                type="primary"
                @click="onConfirmIssuance">
                确定下发
            </el-button>
            <el-button :loading="submitLoading" @click="onClose">取消</el-button>
        </div>
    </el-dialog>
</template>
<script>
import PerDialog from '@/components/lots/Dialog/personDialog/Person'
import GroupDialog from '../../../../components/personOne/groupDialog.vue';
import { updateSupplierLegalPersonPerformanceStatus } from '../../../../api/performManage.js'

export default {
    props: {},
    components: { PerDialog,GroupDialog },
    data() {
        return {
            dialogShow: false,
            submitLoading: false,
            isNoNeed: '',
            reason: '',
            rectificationForm: { reason: '', mipName: '', mipCode: '' },
            queryData: {},
            rules: {
                reason: [{ required: true, message: '请输入无需整改原因', trigger: 'blur' }],
                mipName: [{ required: true, message: '点击选择跟进人', trigger: 'change' }],
            },
            openPerDialog: {
                openIndex: '',
                showDialog: false,
                checkedList: []
            },
        }
    },
    mounted() {},
    computed: {
        dialogType() {
            return this.queryData.type
        },
    },
    methods: {
        open(params) {
            this.queryData = params
            this.dialogShow = true
            this.rectificationForm.reason=''
            this.rectificationForm.mipCode=''
            this.rectificationForm.mipName=''
            this.$nextTick(() => {
                this.$refs['rectificationForm'].clearValidate()
            })
        },
        handleOpenGroup() {
            let checkedList = []
            if (this.rectificationForm.mipCode) {
                checkedList = [{ userCode: this.rectificationForm.mipCode, userName: this.rectificationForm.mipName }]
            }
            this.openPerDialog = { openIndex: '0', showDialog: true, checkedList }
        },
        overPerDialog(data) {
            this.openPerDialog.showDialog = data.open
            if (data.checklist.length) {
                this.rectificationForm.mipCode = data.checklist[0].userCode
                this.rectificationForm.mipName = data.checklist[0].userName
            }
        },
        closePerDialog(data) {
            this.openPerDialog.showDialog = data.open
        },
        
        handlePreview(row) {
            this.attachmentShow = true
            this.fileRowData = {
                downUrl: row.fileUrl,
                fileName: row.fileName,
                fileId: row.id,
            }
        },

        onClose() {
            this.dialogShow = false
        },
        //无需整改
        onConfirm() {
            this.$refs['rectificationForm'].validate(valid => {
                if (valid) {
                    let idsList = []
                    for (const item of this.queryData.selectList) {
                        idsList.push(item.id)
                    }
                    let params = {
                        ids: idsList,
                        operativeFunctionReason: this.rectificationForm.reason,
                        performanceDimension:'',
                        operativeFunction: '16', //16： 无需整改
                    }
                    this.submitLoading = true
                    updateSupplierLegalPersonPerformanceStatus(params)
                        .then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success(res.msg)
                                this.$emit('refresh')
                            }
                        })
                        .finally(() => {
                            this.submitLoading = false
                            this.onClose()
                        })
                }
            })
        },
        //下发整改
        onConfirmIssuance() {
            this.$refs['rectificationForm'].validate(valid => {
                if (valid) {
                    let idsList = []
                    for (const item of this.queryData.selectList) {
                        idsList.push(item.id)
                    }
                    let params = {
                        ids: idsList,
                        mipName: this.rectificationForm.mipName,
                        mipCode: this.rectificationForm.mipCode,
                        operativeFunction: '15', //15： 下发整改
                        autoDistributionFlag: false,
                    }
                    this.submitLoading = true
                    updateSupplierLegalPersonPerformanceStatus(params)
                        .then(res => {
                            if (res && +res.code === 0) {
                                this.$message.success(res.msg)
                                this.$emit('refresh')
                            }
                        })
                        .finally(() => {
                            this.submitLoading = false
                            this.onClose()
                        })
                }
            })
        },
    },
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog__header {
    display: none;
}

.rectification-dialog-container {
    .required {
        color: red;
    }
}
</style>
